// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ProgramV1GetProgramDefaultResponse {
    static getAttributeTypeMap() {
        return ProgramV1GetProgramDefaultResponse.attributeTypeMap;
    }
}
ProgramV1GetProgramDefaultResponse.discriminator = undefined;
ProgramV1GetProgramDefaultResponse.additionalProperties = false;
ProgramV1GetProgramDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ProgramV1GetProgramDefaultResponseData"
    },
];
//# sourceMappingURL=programV1GetProgramDefaultResponse.js.map